import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { VitalChartSC } from './vital-chart.styled';
import VitalChartDot from './vital-chart-dot';

type TProps = {
  unit?: string;
  value?: string | number;
  isMini?: boolean;
  graphStates: string[];
  degrees: number[];
  oneSidedRange?: boolean;
  className?: string;
  style?: React.CSSProperties;
  showStatus?: boolean;
};

const VitalChart: React.FC<TProps> = ({
  unit,
  value,
  isMini,
  graphStates,
  degrees,
  oneSidedRange,
  className,
  style,
}) => {
  const colors = useMemo(
    () =>
      graphStates.map((state) => {
        switch (state) {
          case 'normal':
            return '#6AE59F';
          case 'raised':
          case 'lowered':
            return '#A3987F';
          case 'high':
          case 'low':
            return '#FF335C';
          default:
            return '#E1E2E8';
        }
      }),
    [graphStates],
  );

  const textColor = useMemo(() => {
    return colors[0];
  }, [colors]);

  return (
    <VitalChartSC isMini={isMini} className={className} style={style}>
      <img
        src={
          oneSidedRange
            ? require('../../../../assets/png/circle-chart-positive.png')
            : require('../../../../assets/png/vital-chart.png')
        }
        alt=""
      />

      {value && unit ? (
        <div className="vc-data">
          <b style={{ color: textColor }}>{value}</b>
          <span style={{ color: textColor }}>
            <FormattedMessage id={unit} />
          </span>
        </div>
      ) : null}
      {degrees.map((degree, i) => (
        <VitalChartDot color={colors[i]} degree={degree} key={`${i}`} />
      ))}
    </VitalChartSC>
  );
};

export default React.memo(VitalChart);
